export default {
      id: "lock-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#lock",
      toString: function () {
        return this.url;
      }
    }